module.exports = __webpack_public_path__ + "img/arrow-right-white.9cca4f9b.svg";